import { Channel, ChannelType } from '@/types/channel.types';
import { EventType } from '@/types/projects.types';

export default function getAllowedProjectTypesForChannel(channel: Channel): Array<EventType> {
  switch (channel.type) {
    case ChannelType.BrandTV:
      return [EventType.Townhall, EventType.Event];
    case ChannelType.Webinar:
      return [EventType.Webinar, EventType.Event];
    case ChannelType.VirtualPro:
      return [];
    default:
      return [EventType.Event];
  }
}
